import addDays from '@stencil/date-utils/src/addDays';
import {appConfig} from '@stencil/hotels-config';
import {UPDATE_SELECTED_PROPERTY} from '../../hotels-details-reducer/src/constants';

import {
  CommonActionTypes,
  ICommonStoreState,
  UPDATE_QUERY,
  ERROR_LOADING_SEGMENT_SLIDER,
  RESET_SEGMENT_SLIDER,
  TOGGLE_LOADING_SEGMENT_SLIDER,
  UPDATE_SEGMENT_SLIDER_DATA,
  RESET_SELECTED_PROPERTY,
  UPDATE_AUTOSUGGEST_OPENED_BY,
  UPDATE_PAGEHEADER_SEARCH_WIDGET_OPEN_STATE,
  UPDATE_CALENDAR_PROGRESSIVE_SEARCH_FORM_OPENED_BY,
} from './types';

const {
  defaultRoomString,
  defaultPartner,
  defaultCountry,
  defaultCheckinOffset,
  defaultCheckoutOffset,
} = appConfig;

const initialState: ICommonStoreState = {
  country: defaultCountry,
  destination: {n: '', _id: ''},
  partner: defaultPartner,
  checkin: {
    date: addDays(new Date(), defaultCheckinOffset),
    isMidnight: false,
    isMachineGenerated: true,
  },
  checkout: {
    date: addDays(new Date(), defaultCheckoutOffset),
    isMidnight: false,
    isMachineGenerated: true,
  },
  roomString: defaultRoomString,
  metaPartner: '',
  segmentSliderApi: {
    isLoading: true,
    data: {},
    error: null,
  },
  selectedHotel: {
    propertyId: '',
    propertyVendor: '',
    propertyName: '',
    hmd: '',
    queryParamsForReviewUrlPropsBase64: {},
    descBlockInput: {},
    ecomParams: {},
    reviewType: null,
  },
  autosuggestOpenedBy: '',
  calenderProgressiveSearchFormOpenedBy: '',
  isPageHeaderSearchWidgetOpen: false,
};

export default function srpPageReducer(state = initialState, action: CommonActionTypes) {
  switch (action.type) {
    case UPDATE_QUERY:
      return {
        ...state,
        ...action.actionData,
      };

    case UPDATE_SEGMENT_SLIDER_DATA:
      return {
        ...state,
        segmentSliderApi: {
          ...state.segmentSliderApi,
          data: {...state.segmentSliderApi.data, ...action.actionData},
        },
      };

    case TOGGLE_LOADING_SEGMENT_SLIDER:
      return {
        ...state,
        segmentSliderApi: {
          ...state.segmentSliderApi,
          isLoading: action.actionData,
        },
      };

    case ERROR_LOADING_SEGMENT_SLIDER:
      return {
        ...state,
        segmentSliderApi: {
          ...state.segmentSliderApi,
          error: action.actionData,
          isLoading: false,
        },
      };

    case RESET_SEGMENT_SLIDER:
      return {
        ...state,
        segmentSliderApi: {
          isLoading: true,
          data: {},
        },
      };

    case UPDATE_SELECTED_PROPERTY:
      return {
        ...state,
        selectedHotel: {
          ...state.selectedHotel,
          propertyId: action.payload?.propertyId || state.selectedHotel.propertyId || '',
          propertyName: action.payload?.propertyName || state.selectedHotel.propertyName || '',
          propertyVendor:
            action.payload?.propertyVendor || state.selectedHotel.propertyVendor || '',
          hmd: action.payload?.hmd || state.selectedHotel.hmd,
          queryParamsForReviewUrlPropsBase64:
            action.payload?.queryParamsForReviewUrlPropsBase64 ||
            state.selectedHotel.queryParamsForReviewUrlPropsBase64 ||
            {},
          descBlockInput:
            action.payload?.descBlockInput || state.selectedHotel.descBlockInput || {},
          ecomParams: action.payload?.ecomParams || state.selectedHotel.ecomParams || {},
          reviewType: action.payload?.reviewType || state.selectedHotel.reviewType || null,
        },
      };

    case RESET_SELECTED_PROPERTY:
      return {
        ...state,
        selectedHotel: initialState.selectedHotel,
      };
    case UPDATE_AUTOSUGGEST_OPENED_BY:
      return {
        ...state,
        autosuggestOpenedBy: action?.payload?.page,
      };

    case UPDATE_CALENDAR_PROGRESSIVE_SEARCH_FORM_OPENED_BY:
      return {
        ...state,
        calenderProgressiveSearchFormOpenedBy: action?.payload?.page,
      };

    case UPDATE_PAGEHEADER_SEARCH_WIDGET_OPEN_STATE:
      return {
        ...state,
        isPageHeaderSearchWidgetOpen: action.payload?.isPageHeaderSearchWidgetOpen,
      };
    default:
      return state;
  }
}
